<template>
  <div
    class="txt-doc"
    :class="mixClasses"
  >
    <component
      :is="component"
      class="txt-doc__txt"
      v-bind="$attrs"
    >
      <span class="text-content">
        {{ text }}
      </span>
      <span class="new-doc">{{ $t('tenantProjects.docs') }}</span>
    </component>
  </div>
</template>

<script>
import { computed } from 'vue-demi'

export default {
  props: {
    text: {
      type: String,
      default: () => '',
    },
    rtl: {
      type: Boolean,
      default: false,
    },
    component: {
      type: [String, Object, Function],
      default: 'span',
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    return {
      mixClasses: computed(() => [
        props.rtl && 'reverse',
        props.inline && 'inline',
      ]),
    }
  },
}
</script>

<style lang="scss" scoped>
.txt-doc {
  display: flex;
  align-items: center;
  &.reverse {
    flex-direction: row-reverse
  }
  &.inline {
    display: inline-flex;
  }
  .text-content {
    margin-right: 10px
  }
  .new-doc {
    position: relative;
    padding: 0 5px;
    height: 14px;
    line-height: 14px;
    font-size: 9px;
    color: #ffffff;
    letter-spacing: 0.1px;
    background-color: #e49405;
    vertical-align: middle;
    display: inline-block;
    &::before {
      position: absolute;
      content: "";
      right: 100%;
      top: 0px;
      width: 0;
      height: 0;
      border: 7px solid transparent;
      border-right: 5px solid #e49405;
    }
  }
}
</style>
